var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxCheck = function SvgBoxCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.514 18H23.4V8.4H12.78zm30.975 0L35.22 8.4H24.6V18zM8.4 19.2v20.4h31.2V19.2zm3.6-12h24L40.8 18v22.8H7.2V18zm19.63 17.228-9.6 9.6-.428.427-.427-.427-4.8-4.8-.428-.428.855-.847.428.427 4.372 4.373 9.173-9.18.427-.428.848.855-.428.428z"
  })));
};
export default SvgBoxCheck;